import React from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Projects.css";

// Import project images
import codesage from "../../assets/Projects/codesage.png";
import speedline from "../../assets/Projects/speedline.png";
import blueguard from "../../assets/Projects/blueguard.png";
import obfuspower from "../../assets/Projects/obfuspower.png";

export default function Projects(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreens(props.id);
  };

  // eslint-disable-next-line no-unused-vars
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const projectsData = [
    {
      name: "CodeSage",
      image: codesage,
      description: "AI-powered platform for real-time voice-based technical and resume interviews with live transcription and dynamic question generation. Track past interviews with interactive analytics and actionable insights.",
      website: "https://drive.google.com/file/d/1MIDfHyVFTcc932WOg3A-9mtG24dzwr50/view?usp=sharing",
      github: "https://github.com/AashiJain971/codeSage"
    },
    {
      name: "SpeedLine",
      image: speedline,
      description: "Real-time train traffic management system with live geographic tracking, AI-powered route optimization, and conflict detection. Provides instant insights and interactive simulations to help operators monitor, plan, and resolve disruptions efficiently.",
      website: "https://speedline-frontend.onrender.com",
      github: "https://github.com/AashiJain971/speedLineNew"
    },
    {
      name: "BlueGuard",
      image: blueguard,
      description: "Detects malicious IP activity on Apache/Nginx servers in real time using rule-based and ML analysis. Delivers instant alerts and interactive insights for fast, actionable threat detection.",
      website: "https://drive.google.com/file/d/1Z3sH4IUHZWZxjOOyJtAk6ljLgHZlgGgQ/view",
      github: "https://github.com/AashiJain971/Blue_Guard"
    },
    {
      name: "ObfusPower",
      image: obfuspower,
      description: "A red-team inspired Python tool that reconstructs PowerShell commands using environment variable indexing to bypass static analysis. Designed for blue-team awareness, malware analysis, and defensive research.",
      github: "https://github.com/AashiJain971/powerShell_env_obfuscation_EduactionalDemo"
    }
  ];

  return (
    <div className="projects-section-container screen-container fade-in" id={props.id || ""}>
      <div className="projects-section-parent">
        <ScreenHeading title={"Projects"} subHeading={"My Recent Work"} />
        <div className="projects-grid">
          {projectsData.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-image-container">
                <img src={project.image} alt={project.name} className="project-image" />
              </div>
              <div className="project-content">
                <h3 className="project-name">{project.name}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-links">
                  {project.website && (
                    <a href={project.website} target="_blank" rel="noopener noreferrer" className="project-link">
                      <i className="fa fa-globe"></i>
                      <span>View Demo</span>
                    </a>
                  )}
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
                      <i className="fa fa-github"></i>
                      <span>GitHub</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
